import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
import { transfersFromCached } from '../../../lib/common'
import * as orderConstant from './constants'

import * as orderAaction from './actions'
function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function nvkdRequestApi(formData) {
  const request = axiosApi().post(
    orderConstant.ORDER_REPORT_NVKD_API,
    formData
  )

  return handleRequest(request);
}
function* orderReportNvkdRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(nvkdRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(orderAaction.orderReportNvkdSuccess(results.data))

  } catch (error) {
    yield put(orderAaction.orderReportNvkdError(error))
  }
}
function khRequestApi(formData) {
  const request = axiosApi().post(
    orderConstant.ORDER_REPORT_KH_API,
    formData
  )

  return handleRequest(request);
}
function* orderReportKhRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const { data } = yield call(khRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(orderAaction.orderReportKhSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(orderAaction.orderReportKhError(error))
  }
}
function khoXuatRequestApi(formData) {
  const request = axiosApi().post(
    orderConstant.ORDER_REPORT_KHOXUAT_API,
    formData
  )

  return handleRequest(request);
}
function* orderReportKhoXuatRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const { data } = yield call(khoXuatRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(orderAaction.orderReportKhoXuatSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(orderAaction.orderReportKhoXuatError(error))
  }
}
function listRequestApi(formData) {
  const request = axiosApi().post(
    orderConstant.ORDER_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}
function* orderReportListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(orderAaction.orderReportListSuccess(results.data))

  } catch (error) {
    yield put(orderAaction.orderReportListError(error))
  }
}
function exportXlsRequestApi(formData) {
  const url = orderConstant.REPORT_EXPORT_XLS_API + "?s=" + formData.store_id + "&st=" + formData.tu_ngay + "&ed=" + formData.den_ngay
    + "&ldh=" + formData.loaiDonHang + "&ql=" + formData.treeQL + "&kd=" + formData.listNvkd
    + "&nkh=" + formData.listNhomKh + "&kh=" + formData.listKH + "&kx=" + formData.listKhoXuat + "&tt=" + formData.trangThai + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(orderAaction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(orderAaction.reportExportXlsError(error))
  }
}
function* orderReportNhomKhRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      orderConstant.ORDER_REPORT_NHOMKH_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(orderAaction.orderReportNhomKhSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }

  } catch (error) {
    yield put(orderAaction.orderReportNhomKhError(error))
  }
}
function* orderReportKhByNhomRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      orderConstant.ORDER_REPORT_KH_BY_NHOM_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    const data = transfersFromCached(results.data)
    yield put(orderAaction.orderReportKhByNhomSuccess(data))
    if (typeof callback == 'function') {
      yield call(callback, data);
    }

  } catch (error) {
    yield put(orderAaction.orderReportKhByNhomError(error))
  }
}
function* orderReportWatcher() {
  yield [
    takeLatest(orderConstant.ORDER_REPORT_NVKD_REQUESTING, orderReportNvkdRequestFlow),
    takeLatest(orderConstant.ORDER_REPORT_KHOXUAT_REQUESTING, orderReportKhoXuatRequestFlow),
    takeLatest(orderConstant.ORDER_REPORT_KH_REQUESTING, orderReportKhRequestFlow),
    takeLatest(orderConstant.ORDER_REPORT_LIST_REQUESTING, orderReportListRequestFlow),
    takeLatest(orderConstant.REPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(orderConstant.ORDER_REPORT_NHOMKH_REQUESTING, orderReportNhomKhRequestFlow),
    takeLatest(orderConstant.ORDER_REPORT_KH_BY_NHOM_REQUESTING, orderReportKhByNhomRequestFlow),
  ]
}

export default orderReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/OrderReport/sagas.js